import { TReduxActions } from '../../../common/actions';
import { EFavoritesActionType } from '../../../common/actions/favorites';
import { EAddToFavoritesActionTypes } from '../../../common/actions/newFavorites/addToFavorite';
import { ERemoveFromFavoritesActionTypes } from '../../../common/actions/newFavorites/removeFromFavorite';
import { EMarkAsViewedActionType } from '../../../common/actions/viewed';
import { ITilesMap } from '../../../common/types/map';
import { IPrecisionFeatures } from '../../../common/types/redux/store/features';
import { EFeaturesActionType, EFetchMapDataActionType } from '../../actions';

export const defaultState: IPrecisionFeatures = {};

export function featuresReducer(state: IPrecisionFeatures = defaultState, action: TReduxActions): IPrecisionFeatures {
  switch (action.type) {
    case EFetchMapDataActionType.Succeed: {
      const tiles = action.payload.tiles || [];
      const precision = action.payload.precision as number;

      const featuresMap = action.payload.clusters || {};

      const uniqueTiles: ITilesMap = {};
      tiles.forEach(([x, y]) => {
        uniqueTiles[`${x},${y}`] = [x, y];
      });

      return {
        ...state,
        [precision]: {
          ...state[precision],
          features: featuresMap,
          tiles: uniqueTiles,
        },
      };
    }
    case EFetchMapDataActionType.Failed: {
      return defaultState;
    }

    case EAddToFavoritesActionTypes.Success:
    case EFavoritesActionType.Added: {
      const { currentPrecision, selectedFeatureId, offerId } = action.payload;

      return changeFavoriteValue(state, currentPrecision, selectedFeatureId, offerId, true);
    }

    case ERemoveFromFavoritesActionTypes.Success:
    case EFavoritesActionType.Removed: {
      const { currentPrecision, selectedFeatureId, offerId } = action.payload;

      return changeFavoriteValue(state, currentPrecision, selectedFeatureId, offerId, false);
    }

    case EMarkAsViewedActionType.Succeed: {
      const { precision, featureId } = action.payload;
      const selectedFeature = state[precision]?.features[featureId];

      if (selectedFeature) {
        return {
          [precision]: {
            ...state[precision],
            features: {
              ...state[precision].features,
              [featureId]: {
                ...selectedFeature,
                properties: {
                  ...selectedFeature.properties,
                  offers: selectedFeature.properties.offers.map(offer => ({
                    ...offer,
                    isViewed: true,
                  })),
                },
              },
            },
          },
        };
      }

      return state;
    }

    case EFeaturesActionType.FeaturePropertiesUpdated: {
      const { precision, featureId, properties } = action.payload;
      const selectedFeature = state[precision]?.features[featureId];

      if (selectedFeature) {
        return {
          ...state,
          [precision]: {
            ...state[precision],
            features: {
              ...state[precision].features,
              [featureId]: {
                ...selectedFeature,
                properties: {
                  ...selectedFeature.properties,
                  ...properties,
                },
              },
            },
          },
        };
      }

      return state;
    }

    default:
      return state;
  }
}

function changeFavoriteValue(
  state: IPrecisionFeatures,
  currentPrecision: number,
  selectedFeatureId: string,
  offerId: number,
  value: boolean,
): IPrecisionFeatures {
  const selectedFeature = state[currentPrecision].features[selectedFeatureId];

  if (selectedFeature) {
    return {
      [currentPrecision]: {
        ...state[currentPrecision],
        features: {
          ...state[currentPrecision].features,
          [selectedFeatureId]: {
            ...selectedFeature,
            properties: {
              ...selectedFeature.properties,
              offers: selectedFeature.properties.offers.map(offer => ({
                ...offer,
                isFavorite: offerId === offer.realtyId ? value : offer.isFavorite,
              })),
            },
          },
        },
      },
    };
  }

  return state;
}
